import { render, staticRenderFns } from "./ToolboxConfigDialog.vue?vue&type=template&id=4f136d0a&scoped=true"
import script from "./ToolboxConfigDialog.vue?vue&type=script&lang=js"
export * from "./ToolboxConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./ToolboxConfigDialog.vue?vue&type=style&index=0&id=4f136d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f136d0a",
  null
  
)

export default component.exports